import { render, staticRenderFns } from "./PAQuotePosted.vue?vue&type=template&id=23e54666&"
import script from "./PAQuotePosted.vue?vue&type=script&lang=js&"
export * from "./PAQuotePosted.vue?vue&type=script&lang=js&"
import style0 from "./PAQuotePosted.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PAQuotePosted.vue"
export default component.exports